var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "fit-content" } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _vm._l(_vm.upElementBlocksList, function(upElementBlocks, index) {
            return [
              upElementBlocks.length > 0
                ? _c(
                    "div",
                    {
                      key: index,
                      staticClass: "section form-column",
                      style: { width: upElementBlocks[0].width + "px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "130px",
                            "label-position": "right"
                          }
                        },
                        [
                          _vm._l(upElementBlocks, function(item, subIndex) {
                            return [
                              _c(
                                "span",
                                {
                                  key: subIndex,
                                  staticClass: "title",
                                  staticStyle: { width: "100%" }
                                },
                                [
                                  item.name === "podPortInfo"
                                    ? _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            width: "200",
                                            trigger: "hover"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "pop-content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PodPortInfoPrompt"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("svg-icon", {
                                            staticStyle: {
                                              "font-size": "14px",
                                              "margin-top": "-3px"
                                            },
                                            attrs: {
                                              slot: "reference",
                                              "icon-class": "question"
                                            },
                                            slot: "reference"
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(item.title) + " ")
                                ],
                                1
                              ),
                              _vm._l(item.elementNames, function(elementName) {
                                return _vm._t(elementName)
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          }),
          _vm._t("shipperConsignNotify")
        ],
        2
      ),
      !!_vm.downElementBlock
        ? _c(
            "div",
            { staticClass: "section", staticStyle: { width: "100%" } },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.downElementBlock.title))
              ]),
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { display: "flex", "flex-direction": "row" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "160px",
                        "label-position": "right"
                      }
                    },
                    [
                      _vm._l(_vm.downElementBlock.elementNames, function(
                        elementName
                      ) {
                        return _vm._t(elementName)
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._t("ediReceipt"),
      _vm._t("ediReceiptCommon")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }